import { useStore } from 'effector-react'
import * as React from 'react'

import { $gift, giftMounted, getGift } from '../edit/model'

export const useGiftDetails = () => {
  const gift = useStore($gift)
  const loading = useStore(getGift.pending)

  React.useEffect(() => {
    giftMounted()
  }, [])

  return { gift, loading }
}
